module.exports = __webpack_public_path__ + "img/service1.3606bb71.png";